import { createMemo, Show, useContext } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListItemTextPropsType } from '~/types/ListItemText'
import { ListContext } from './List'

export default function ListItemText(props: ListItemTextPropsType) {
  const listContext = useContext(ListContext)

  const containerClasses = createMemo(() => twMerge('flex-grow min-w-0', props.inset && 'ml-14', props.class))

  const primaryClasses = createMemo(() => twMerge('font-medium', listContext.dense ? 'text-sm leading-5' : 'text-base leading-6', 'text-foreground', 'break-words'))

  const secondaryClasses = createMemo(() => twMerge('text-xs leading-4 mt-0.5', 'text-foreground-subtle', 'break-words'))

  return (
    <div class={containerClasses()} classList={props.classList}>
      <Show when={props.primary}>
        <div class={primaryClasses()}>{props.primary}</div>
      </Show>
      <Show when={props.secondary}>
        <div class={secondaryClasses()}>{props.secondary}</div>
      </Show>
    </div>
  )
}
